import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllAboutUsImage = createAsyncThunk('aboutUs/getAllAboutUsImage', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/about-us`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const createAboutUsImage = createAsyncThunk('aboutUs/createAboutUsImage', async ({ payload }, thunkAPI) => {
  try {
    await axiosInstance.post(`/about-us`, { ...payload });
    thunkAPI.dispatch(getAllAboutUsImage());
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const uploadAboutUsImage = createAsyncThunk(
  'aboutUs/uploadAboutUsImage',
  async ({ payload, data }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/about-us/upload`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const uploadedImageString = response.data?.file;
      if (!uploadedImageString) return thunkAPI.rejectWithValue('Gagal Upload Image');

      thunkAPI.dispatch(createAboutUsImage({ payload: { ...data, image: uploadedImageString } }));
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
    }
  },
);

export const deleteAboutUsImage = createAsyncThunk('aboutUs/deleteAboutUsImage', async (id, thunkAPI) => {
  try {
    await axiosInstance.delete(`/about-us/${id}`);
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
